import { DELETE, GET, PATCH, POST } from '../../common/common.service'
import endpointsShoppingCart from './endpoints'

export const ShoppingCartService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsShoppingCart.LOAD(filter, sort, limit, skip)),
  create: async (body) => POST(endpointsShoppingCart.CREATE, body),
  duplicate: async (id) => POST(endpointsShoppingCart.DUPLICATE(id)),
  getById: async (id) => GET(endpointsShoppingCart.BY_ID(id)),
  update: async ({ _id, body }) =>
    PATCH(endpointsShoppingCart.BY_ID(_id), body, false),
  remove: async (id) => DELETE(endpointsShoppingCart.BY_ID(id)),
  removeAll: async () => DELETE(endpointsShoppingCart.CREATE),
  getProvinces: async () => GET(endpointsShoppingCart.PROVINCES),
}
